import { Dialog } from '@cw-ui/feedback-components';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';
import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { useHandleFileDeleteMutation } from '../../services/bulkUserImportService';
import {
    setRemoveCurrentFileDialogOpen,
    setRemoveFileFailedAlert,
    setRemoveFileSuccessAlert,
    bulkImportUsersSliceId,
    deleteFileReducer,
    setIsRemoveFileLoading,
    setOverallTotalItems,
} from '../../slice';
import * as Styled from './RemoveFileDialog.styled';

const RemoveFileDialog = () => {
    const dispatch = useDispatch();
    const [handleFileDelete] = useHandleFileDeleteMutation();
    const currentUploadId = useSelector(state => state[bulkImportUsersSliceId]?.currentUploadId);
    const handleClose = () => {
        dispatch(setRemoveCurrentFileDialogOpen());
    };

    const handleRemoveFile = async () => {
        handleClose();
        try {
            dispatch(setIsRemoveFileLoading(true));
            await handleFileDelete({ uploadId: currentUploadId }).unwrap();
            dispatch(setRemoveFileSuccessAlert());
            dispatch(deleteFileReducer());
            dispatch(setOverallTotalItems(0));
        } catch (error) {
            dispatch(setRemoveFileFailedAlert());
        } finally {
            dispatch(setIsRemoveFileLoading(false));
        }
    };

    return (
        <Dialog
            open
            onClose={handleClose}
            aria-labelledby="remove-file-dialog-title"
            aria-describedby="remove-file-dialog-description">
            <Styled.DialogTitle id="remove-file-dialog-title">
                {formatMessage(Locale.bulkUserImportRemoveFileHeader)}
            </Styled.DialogTitle>
            <Styled.Icon aria-label="close" onClick={handleClose}>
                <CloseIcon />
            </Styled.Icon>
            <Styled.DialogContent>{formatMessage(Locale.bulkUserImportModalHeaderContent)}</Styled.DialogContent>
            <Styled.Actions>
                <Button size="medium" variant="outlined" color="secondary" onClick={handleClose}>
                    {formatMessage(Locale.cancel)}
                </Button>
                <Button size="medium" variant="contained" color="dangerPrimary" onClick={handleRemoveFile}>
                    {formatMessage(Locale.removeFile)}
                </Button>
            </Styled.Actions>
        </Dialog>
    );
};

export default RemoveFileDialog;
